exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2VR7s{height:auto;width:100%;color:#fff;text-align:center}._2Lc5M{opacity:0;width:50px;height:50px;position:absolute;left:48%}._2Lc5M:hover{cursor:pointer}._2tgoQ{display:block;padding:.5em;text-align:center;border-bottom:1px solid #9e9e9e}._2tgoQ:before{content:url(" + require("./images/icono_plus.png") + ");display:inline-block;width:40px;height:40px}.DJte0{height:0;overflow:hidden}._2Lc5M:checked~.DJte0,.DJte0{-webkit-transition-duration:.5s;-o-transition-duration:.5s;transition-duration:.5s}._2Lc5M:checked~.DJte0{height:320px}._2Lc5M:checked~._2tgoQ:before{content:url(" + require("./images/icono_menos.png") + ")}._1vVgX{max-width:970px}", ""]);

// exports
exports.locals = {
	"root": "_2VR7s",
	"toggle": "_2Lc5M",
	"label": "_2tgoQ",
	"collapsed": "DJte0",
	"container": "_1vVgX"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Accordion/Accordion.css
// module id = 1099
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13